





















































































import { Component, PropSync, Vue, Prop, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { email, integer, minLength, numeric, required, requiredIf } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import { OrgsApi, ProductsApi } from '../../api';
import addOrg from '@/components/add business objects/addOrg.vue';
import addOrgAdmin from '@/components/add business objects/addOrgAdmin.vue';
import addBilling from '@/components/add business objects/addBilling.vue';
import addSite from '@/components/add business objects/addSite.vue';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		addSite,
		addOrg,
		addOrgAdmin,
		addBilling,
		vSelect,

		Toast,
	},
	validations: {
		job: {
			notes: {
				required: requiredIf(function() {
					return this.localProduct.type === 'milk' && this.jobRequired;
				}),
			},
			status: {
				required: requiredIf(function() {
					return this.localProduct.type === 'milk' && this.jobRequired;
				}),
			},
			zone: {
				required: requiredIf(function() {
					return this.localProduct.type === 'milk' && this.jobRequired;
				}),
			},
			type: {
				required: requiredIf(function() {
					return this.localProduct.type === 'milk' && this.jobRequired;
				}),
			},
		},
	},
	mixins: [validationMixin],
})
export default class OldAddJob extends Vue {
	public jobRequired = true;
	public emailRequired = true;
	public billingRequired = true;
	public loading = false;

	@PropSync('org') public localOrg!: object;

	@PropSync('product') public localProduct!: object;

	@Prop(String)
	public jobDescription!: string;

	@Prop(String)
	public jobModalId!: string;

	@Prop() public faults!: any[];
	public faultsList = [];
	public notes = '';
	public repairTypeEnabled = false;

	public job: any = {
		notes: this.jobDescription || '',
		status: '',
		zone: undefined,
		type: '',
	};
	public selectedFaults = [];

	public jobOptions = [
		{ value: 7, text: 'New Service' },
		{ value: 11, text: 'On Hold' },
		{ value: 60, text: 'Priority' },
		{ value: 27, text: 'Needs equipment - lidded' },
		{ value: 28, text: 'Needs equipment - Longveld' },
		{ value: 61, text: 'Vee bottom (may be lidded)' },
	];

	public jobTypes = [
		{ value: 'install', text: 'Install' },
		{ value: 'repair', text: 'Repair', disabled: this.repairTypeEnabled },
		{ value: 'remove', text: 'Remove' },
	];

	public zoneOptions = [
		{ numeric: 7, alpha: 'Bay of Plenty', text: 'Bay of Plenty' },
		{ numeric: 5, alpha: 'Canterbury', text: 'Canterbury' },
		{ numeric: 4, alpha: 'Central Districts', text: 'Central Districts' },
		{ numeric: 2, alpha: 'Northland', text: 'Northland' },
		{ numeric: 3, alpha: 'Southland and Otago', text: 'Southland and Otago' },
		{ numeric: 6, alpha: 'Taranaki', text: 'Taranaki' },
		{ numeric: 1, alpha: 'Waikato', text: 'Waikato' },
	];

	public $bvToast: any;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public region: any = null;
	public siteRegion: any = null;

	private api: ProductsApi = new ProductsApi();

	@Watch('selectedFaults')
	public selectedFaultChanged() {
		this.job.notes = `${this.jobDescription}${this.selectedFaults.join(', ')}`;
	}

	// @Watch('localProduct')
	public created() {
		if (this.jobModalId.startsWith('JobModalFaults')) {
			this.job.type = 'repair';
		}
		if (this.localProduct.fssRegion) {
			const region = this.zoneOptions.find(option => option.alpha === this.localProduct.fssRegion);
			this.job.zone = region ? region.numeric : undefined;
		}
		this.createFaultsList();
	}

	public clearJob() {
		this.job = {
			notes: '',
			status: '',
			type: '',
		};
		if (this.localProduct.fssRegion) {
			const region = this.zoneOptions.find(option => option.alpha === this.localProduct.fssRegion);
			this.job.zone = region ? region.numeric : undefined;
		}
		this.$v.$reset();
	}

	public stepValidate(name: string, e: Event) {
		e.preventDefault();
		const form = this.$v[name];
		form.$touch();
		if (form.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		if (this.localProduct.status === 'live' && this.job.type === 'install') {
			if (
				!confirm(
					'WARNING: the product status will change from live to install are you sure you wish to continue?',
				)
			) {
				return;
			}
		}
		if (!form.$invalid) {
			this.onComplete();
		}
	}

	public async onComplete() {
		this.submitStatus = 'PENDING';
		const productId = this.localProduct.id;
		const job = {
			notes: this.job.notes,
			status: this.job.status,
			zone: this.job.zone,
			type: this.job.type,
		};
		try {
			await this.api.productJob(parseInt(productId, 10), { data: job });
			if (this.job.status === 11) {
				await this.api.updateProduct(parseInt(productId, 10), {
					data: { orgId: this.localOrg.id, notes: this.notes },
				});
			}
		} catch (e) {
			let error;
			if (e.response) {
				if (e.response.data.message) {
					error = 'Job not created ' + e.response.data.message;
				}
			} else if (e.request) {
				error = 'Job not created, network Error';
			} else {
				error = 'Job not created, unknown Error';
			}
			new Toast().makeToast(error, 'Error Creating Job', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'OK';
		new Toast().makeToast('Installer Simpro Job', 'Job Created', 'success');
		this.$emit('loadJob');
		this.$bvModal.hide(this.jobModalId);
		this.$v.$reset();
		this.clearJob();
	}

	@Watch('faults')
	public createFaultsList() {
		this.faults.forEach((fault: { status: string; ownerType: string; name: any }) => {
			if (['active', 'monitor', 'rebooting', 'repair'].includes(fault.status)) {
				this.faultsList.push(`${fault.name || ''} on ${this.getFaultOn(fault)} (${fault.status})`);
			}
		});
		if (this.faultsList.length > 0) {
			this.repairTypeEnabled = true;
		}
	}

	public getFaultOn(fault: any) {
		switch (fault.ownerType) {
			case 'transceivers':
				return `Transceiver: ${fault.owner.serialNumber}`;
			case 'products':
				return `Product: ${this.product.name || ''}`;
			case 'sensors':
				return `Sensor: ${fault.owner.serialNumber ? fault.owner.serialNumber : ''}`;
			case 'tanks':
				const matchingTank = this.product.tanks.filter(
					(tank: any) => fault.owner.fuelTankId === tank.fuelTankId,
				);
				return `Tank: ${matchingTank.length > 0 ? matchingTank[0].name : ''}`;
		}
		return 'Unknown';
	}
}
